import { authAPI, publicAuthAPI } from "./baseApi";
import { IDefaultCreateResponse } from "./types";

export interface IResetPassword {
    token: string;
    newPassword: string;
}

export interface IRegisterUserRequest {
    fullName: string;
    email: string;
    username: string;
    password: string;
}

export interface IUserExistsParams {
    email?: string;
    username?: string;
}

export interface IUserExistsResponse {
    userExists: boolean;
}

export interface IPasswordRecoveryRequest {
    email: string;
    loginPageUrl: string;
}

export interface IValidateEmailRequest {
    code: string;
}

export async function resetPassword(data: IResetPassword) {
    return await publicAuthAPI.post("/users/reset-password", data);
}

export async function registerUser(data: IRegisterUserRequest) {
    return await publicAuthAPI.post<IDefaultCreateResponse>("/users/register", data);
}

export async function checkUserExists(params: IUserExistsParams) {
    return await publicAuthAPI.get<IUserExistsResponse>("/users/exists", {
        params,
    });
}

export async function sendPasswordRecovery(data: IPasswordRecoveryRequest) {
    return await publicAuthAPI.post("/users/password-recovery", data);
}

export async function sendVerificationEmail() {
    return await authAPI.post("/users/send-verification-email");
}

export async function validateEmail(data: IValidateEmailRequest) {
    return await authAPI.post("/users/validate-email", data);
}
